export { GeneralInformationTabComponent } from './general-information-tab/general-information-tab.component';
export { LeadAcademicInterestComponent } from './lead-academic-interest/lead-academic-interest.component';
export { LeadInteractionsTabComponent } from './lead-interactions-tab/lead-interactions-tab.component';
export { LeadPersonalInformationTabComponent } from './lead-personal-information-tab/lead-personal-information-tab.component';
